import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Door = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 6H20V3C20 2.45 19.55 2 19 2C18.887 2 18.788 2.013 18.687 2.05L8.05 5.6C6.825 6 6 7.15 6 8.438V23.551C6 24.839 6.825 25.989 8.05 26.401L18.687 29.951C18.787 29.989 18.887 30.001 19 30.001C19.55 30.001 20 29.551 20 29.001V26.001H23C24.65 26.001 26 24.651 26 23.001V9.001C26 7.351 24.65 6.001 23 6.001V6ZM8 23.563V8.438C8 8.013 8.275 7.625 8.688 7.488L18.001 4.388V27.613L8.688 24.513C8.276 24.376 8 23.988 8 23.563ZM24 23C24 23.55 23.55 24 23 24H20V8H23C23.55 8 24 8.45 24 9V23Z" />
		<path d="M16 15C16 15.552 15.552 16 15 16C14.448 16 14 15.552 14 15C14 14.448 14.448 14 15 14C15.552 14 16 14.448 16 15Z" />
	</svg>
);

export default Door;
